import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        //当前编号
        navBh: '',
        // isMobile: false,
        // isDesktop: false,
    },
    getters: {

    },
    mutations: {
        setNavBh(state, val){
            state.navBh = val;
            localStorage.setItem("navBh",JSON.stringify(val));
        },
        // setIsMobile(state, val){
        //     state.isMobile = val;
        // },
        // setIsDesktop(state, val){
        //     state.isDesktop = val;
        // },
    },
    actions: {

    },
    modules: {
        
    }
})
